
import Vue from 'vue';

export default Vue.extend({
	name: 'PurpleChip2',
	props: {
		styles: { type: [Object, String], default: null },
	},
	data () {
		return {};
	},
});
